import { UserAttributeDefs } from '../../types/ModelTypes'
import { IPayloadAttributes, IPayloadInstance, PathDirection } from '@iotv/iotv-v3-types'
import { GeoModelCommon } from '../Geo/GeoModelCommon'
import { ThingShadowState } from '../ThingShadowState'

const debug = !process.env.AWS_SESSION_TOKEN && false

export type DeviceEnabledTypeProps = {
  batteryRemainingDays?: number
  deviceBatteryPercentage?: number
  checkForDrop?: boolean
  deviceBatteryVoltage?: number
  /** Populated on networkData update step to enable deviceTransaction and other queries without needing to query for device.*/
  deviceEuis?: string[]
}

class DeviceEnabledType extends GeoModelCommon implements DeviceEnabledTypeProps {
  constructor(type: string, { ...ob }: DeviceEnabledTypeProps = {}) {
    super({ type, ...ob })
    this.batteryRemainingDays = ob.batteryRemainingDays ?? this.batteryRemainingDays
    this.deviceBatteryPercentage = ob.deviceBatteryPercentage ?? this.deviceBatteryPercentage
    this.deviceBatteryVoltage = ob.deviceBatteryVoltage ?? this.deviceBatteryVoltage
    this.deviceEuis = ob.deviceEuis ?? this.deviceEuis
  }

  batteryRemainingDays?: number
  deviceBatteryPercentage?: number
  deviceBatteryVoltage?: number
  checkForDrop?: boolean
  deviceEuis?: string[]

  get shadow() {
    if (!(this.ThingShadowState instanceof Array)) this.ThingShadowState = []
    const lastTSS = this.ThingShadowState[0]
    let shadow = undefined
    if (lastTSS instanceof ThingShadowState) shadow = this.ThingShadowState[0].payload.state
    return shadow
  }

  set shadow(payloadWithshadow) {
    debug &&
      console.log('Setting shadow with ', {
        TSS: this.ThingShadowState,
        payloadWithshadow,
      })

    if (!(this.ThingShadowState instanceof Array && this.ThingShadowState[0] instanceof ThingShadowState)) {
      this.ThingShadowState = [new ThingShadowState(payloadWithshadow)]
      debug && console.log('initialized shadow to', payloadWithshadow)
    }

    if (this.ThingShadowState.length > 0) {
      let update
      if (payloadWithshadow?.payload.state) update = payloadWithshadow.payload
      else if (payloadWithshadow.state) update = payloadWithshadow
      const lastTSS = this.ThingShadowState[0].mergePayload(update)
      this.ThingShadowState.unshift(lastTSS)
      debug && console.log('updated and set head to', lastTSS)
    }
  }

  getUserAttributes(): UserAttributeDefs {
    return {
      ...super.getUserAttributes(),
    }
  }
}

export { DeviceEnabledType }
